import React, { useContext, useEffect, useRef, useState } from "react";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { Toast } from "primereact/toast";
import Card from "../../../../Base/Components/Card/Card";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";
import { Button } from "primereact/button";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../../Base/Services/Moment/Luxon";
import { TabPanel, TabView } from "primereact/tabview";
import { getComprobantesDet, getComprobantesEnc } from "../../../../API/Finanzas/Retencion/ComprobanteRetencionRequest";
import ListadoComprobantesEnc from "./TabListados/ListadoComprobantesEnc";
import ListadoComprobantesDet from "./TabListados/ListadoComprobantesDet";
import ComprobanteRetencionCRUD from "./ComprobanteRetencionCRUD";
import OverlayPanelProveedores from "./Overlays Panel/OverlayPanelProveedores";

const ComprobanteRetencionScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const esAdminFinanzas = [1, 36].includes(userAuth?.IdRol);

  const { config } = useContext(ConfigContext);
  const toast = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [selectedEncabezado, setSelectedEncabezado] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    setSelectedDetalle([]);
    setSelectedEncabezado([]);
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      setLoading(false);
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    if (!activeIndex) {
      const enc = await getComprobantesEnc(fechas);
      setListadoEnc(enc);
    } else {
      const det = await getComprobantesDet(fechas);
      setListadoDet(det);
    }

    setLoading(false);
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Comprobante", config.language));
  }, []);

  useEffect(() => {
    if (dates.length === 2 && dates[0] && dates[1]) {
      getInfo();
    }
  }, [dates, activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        style={{ marginTop: 25 }}
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h3>{getLabel(baseLang, "Comprobante", config.language)}</h3>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button icon="pi pi-refresh" tooltip="Buscar" onClick={getInfo} />

            {activeIndex !== 1 &&(
            <OverlayPanelProveedores/>
            )}

            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />
          </div>
        }
        contenido={
          <div className="pt-1">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Listado Comprobantes">
                  <ListadoComprobantesEnc
                  listadoEnc={listadoEnc}
                  toast={toast}
                  loading={loading}
                  setShowDialog={setShowDialog}
                  selectedDetalle={selectedEncabezado}
                  setSelectedDetalle={setSelectedEncabezado}
                  getInfo={getInfo}
                />
              </TabPanel>

              <TabPanel header="Detalles de Retención">
                  <ListadoComprobantesDet
                  listadoDet={listadoDet}
                  toast={toast}
                  loading={loading}
                  setListadoDet={setListadoDet}
                  setShowDialog={setShowDialog}
                  selectedDetalle={selectedDetalle}
                  setSelectedDetalle={setSelectedDetalle}
                  selectedEncabezado={selectedEncabezado}
                  setSelectedEncabezado={setSelectedEncabezado}
                />
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <ComprobanteRetencionCRUD 
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        selectedEncabezado={selectedEncabezado}
        setSelectedEncabezado={setSelectedEncabezado}
        getInfo={getInfo}
      />
    </div>
  );
};

export default ComprobanteRetencionScreen;
